module.exports = __webpack_public_path__ + "img/floder7.180087e3.png";